import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { forkJoin, map, Observable, of } from 'rxjs';

import { ReportsService } from 'src/app/core/services/reports.service';
import { StudentsService } from 'src/app/core/services/students.service';
import { SessionStorageService } from 'src/app/core/services/session-storage.service';

import { ManagementUser } from 'src/app/core/models/management-user.model';
import { Student } from 'src/app/core/models/student.model';

@Injectable({
    providedIn: 'root'
})
export class CoTeacherResolver {
    constructor(
        private studentService: StudentsService,
        private sessionService: SessionStorageService,
        private reportsService: ReportsService,
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        const managementUser = this.sessionService.getUserData() ;

        return forkJoin([
            this.studentService.getStudents(),
            this.studentService.getGrantedCoTeacherData(),
            (managementUser && managementUser.isTeacherUser()) ? this.reportsService.getAllActiveTeachers(managementUser, managementUser?.schoolID || -1) : of([]),
        ]).pipe(
            map((results) => {
                let students: Student[] = results[0];
                let myCoTeacherData: any = results[1];
                let teachers: ManagementUser[] = results[2];

                students.forEach((student: Student) => {
                    student.fullName = student.firstName + ' ' + student.lastName;
                });

                return {
                    students,
                    myCoTeacherData,
                    teachers,
                };
            })
        );
    }
}
